var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{'text-success': _vm.state === 'SUCCESS', 'text-danger': _vm.state === 'ERROR'}},[_vm._v("\n  "+_vm._s(_vm.state.replace(/_/g, ' '))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }